module.exports = __webpack_public_path__ + "img/country_dark_brown_ba_list.392a6d47.jpg";